import React from "react";
import { Button } from "reactstrap";

import PropTypes from "prop-types";

const getColor = status => {
    if (status === "done") {
        return "btn-success";
    } else if (status === "typing") {
        return "btn-primary";
    } else if (status === "processing") {
        return "btn-warning";
    } else if (status === "rejected") {
        return "btn-danger";
    } else if (status === "disabled") {
        return "btn-secondary";
    } else {
        return "btn-secondary";
    }
}

const ButtonWrapper = ({
    children,
    status,
    ...props
}) => (
    <Button
        color={`btn ${getColor(status)}`}
        {...props}
    >
        {children}
    </Button>
);

ButtonWrapper.propTypes = {
    status: PropTypes.string,
    children: PropTypes.node.isRequired
};

export { ButtonWrapper }
